import { CKChartLine, CKLayoutHorizontal } from 'clearkit';

import { ChartEmptyOverlay } from '~/components/ChartEmptyOverlay';

import { SettingsCard } from '../unified/SettingsCard';
import { useApiUsageData } from './useApiUsageData';

const formatDate = (date: string) => {
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString('en-US', {
    month: 'numeric',
    day: 'numeric',
  });
};

type ChartDatum = {
  x: string;
  y: number;
};

type Chart = {
  data: ChartDatum[];
  id: string;
};

export const APIUsageChart = () => {
  const { data, loading, total } = useApiUsageData();

  const hasData = total !== 0;

  const chartData = [
    {
      data: data.map((item: any) => ({
        x: formatDate(item?.startTime),
        y: item?.count,
      })),
      id: 'Requests',
    },
  ] as Chart[];

  const bottomAxisValues = chartData[0].data
    .filter((_item: ChartDatum, index: number) => index % 2 === 0)
    .map((item: ChartDatum) => item.x);

  return (
    <SettingsCard className="max-w-full">
      <SettingsCard.Header>
        <CKLayoutHorizontal>
          <SettingsCard.Heading>API Usage</SettingsCard.Heading>
        </CKLayoutHorizontal>
      </SettingsCard.Header>
      <SettingsCard.Body className="pt-0 h-80">
        {!loading ? (
          <ChartEmptyOverlay showEmptyState={!hasData}>
            {hasData ? (
              <CKChartLine
                axisBottom={{
                  tickValues: bottomAxisValues,
                }}
                className="h-full"
                data={chartData}
                yScale={{
                  type: 'linear',
                }}
              />
            ) : null}
          </ChartEmptyOverlay>
        ) : null}
      </SettingsCard.Body>
    </SettingsCard>
  );
};
